export default __webpack_public_path__ + "static/media/Group1497-Yono@3x.22390781.png";